import { NoteViewModel } from "../member/GetMemberByFingerprintQuery/NoteViewModel";
import { MemberViewModel } from "../member/MemberViewModel";
import { DefaultMemberViewModel } from '../member/MemberViewModel'

interface MembershipViewModel{
    IsGuest: boolean;
    MembershipTypeId: string;
    Members: MemberViewModel[];
    IsSwinging: boolean;
    IsFetish: boolean;
    IsBlocked: boolean;
    MembershipDue: Date;
    MembershipPaid: boolean;
    Notes: NoteViewModel[];
}

function DefaultMembershipViewModel(): MembershipViewModel {
    return {
      IsGuest: false,
      MembershipTypeId: "",
      Members: [DefaultMemberViewModel()],
      IsSwinging: true,
      IsFetish: false,
      IsBlocked: false,
      MembershipDue: new Date(),
      MembershipPaid: false,
      Notes: []
    }
}
export { DefaultMembershipViewModel }
export type { MembershipViewModel }
